import type { RolesColumnKey } from "@/modules/roles";
/** Rótulo do perfil sem permissões associadas, usado na listagem e nos pop-ups. */
export const NO_PERMISSIONS_LABEL = "sem permissões";

/** Código estável do perfil "Recurso": identifica os profissionais elegíveis em Recursos. */
export const RESOURCE_ROLE_CODE = "RECURSO";

export const RESOURCE_ROLE_DELETE_TOOLTIP = 'O perfil "Recurso" não pode ser excluído.';

export const RESOURCE_ROLE_NAME_HINT = "O nome do perfil Recurso não pode ser alterado.";

export function isResourceRole(role: { codigo: string } | null | undefined): boolean {
  return role?.codigo === RESOURCE_ROLE_CODE;
}

export const ROLES_SEARCH_PLACEHOLDER = "Buscar por código, nome...";

/** Nome base do arquivo exportado quando o serviço não informa um. */
export const ROLES_EXPORT_FILE_NAME = "perfis";
export const ROLES_EXPORT_LIST_NAME = "perfis";

/** Chave do filtro de Permissões na linha de filtros e no resumo da exportação. */
export const ROLES_PERMISSION_FILTER_KEY = "permissoes";
export const ROLES_PERMISSION_FILTER_LABEL = "Permissões";

export const ROLES_FORBIDDEN_MESSAGE = "Você não tem permissão para consultar os perfis do Hub.";
export const ROLES_ERROR_MESSAGE = "Não foi possível carregar os perfis.";

export const ROLES_LOADING_LABEL = "Carregando perfis...";
export const ROLES_ROWS_PER_PAGE_LABEL = "Perfis por página";
export const ROLES_TABLE_LABEL = "Perfis cadastrados";
export const NEW_ROLE_LABEL = "Novo Perfil";

/** MS001 — confirmação do cadastro concluído. */
export const CREATE_SUCCESS_SUMMARY = "Perfil criado com sucesso";
export const CREATE_SUCCESS_MESSAGE =
  "Para adicionar usuários no perfil, vá para a seção usuários.";
/** MS002 — confirmação da edição concluída (comentário da HU 864, de 11/08). */
export const UPDATE_SUCCESS_SUMMARY = "Perfil atualizado com sucesso";
export const UPDATE_SUCCESS_MESSAGE = "As alterações foram salvas com sucesso.";
/** MS003 e MS004 — falhas ao gravar. */
export const CREATE_ERROR_MESSAGE = "Não foi possível cadastrar o perfil. Tente novamente.";
export const UPDATE_ERROR_MESSAGE = "Não foi possível atualizar o perfil. Tente novamente.";
export const CREATE_FORBIDDEN_MESSAGE = "Você não tem permissão para cadastrar os perfis do Hub.";
export const UPDATE_FORBIDDEN_MESSAGE = "Você não tem permissão para editar os perfis do Hub.";

/** MS002 da HU 870 — confirmação da exclusão concluída. */
export const DELETE_SUCCESS_MESSAGE = "Perfil excluído com sucesso";
export const DELETE_ERROR_MESSAGE = "Não foi possível excluir o perfil.";
export const DELETE_FORBIDDEN_MESSAGE = "Você não tem permissão para excluir os perfis do Hub.";

/** O serviço recusa a exclusão de um perfil ainda vinculado a usuários (RN03 da HU 870). */
export const CONFLICT_STATUS = 409;

export type { RolesColumnKey };

export const ROLES_ACTIONS_KEY = "acoes";
export const ROLES_ACTIONS_HEADER = "Ações";
export const ROLES_ACTIONS_WIDTH = "6.625rem";

/** Colunas de dado, na ordem da tabela (Figma 4434:110756); as Ações fecham a linha. */
export const ROLES_COLUMNS = [
  { key: "codigo", header: "Código", width: "10.9375rem" },
  { key: "nome", header: "Nome", width: "15rem" },
  { key: "permissoes", header: "Permissões", width: undefined },
  { key: "quantidadeUsuarios", header: "Usuários", width: "8rem" },
] as const;

/** Todas as colunas, na ordem da tabela: com 6 ou menos a seção de colunas do Configurações da Tabela não aparece. */
export const ROLES_ALL_COLUMNS: readonly RolesColumnKey[] = [
  ...ROLES_COLUMNS.map(({ key }) => key),
  ROLES_ACTIONS_KEY,
];

/** Abaixo disso a tabela rola na horizontal em vez de espremer as colunas. */
export const ROLES_TABLE_MIN_WIDTH = "58rem";
